import { render, staticRenderFns } from "./ConsultantLoggedInNavLocaleSelector.vue?vue&type=template&id=9a29d888&scoped=true"
import script from "./ConsultantLoggedInNavLocaleSelector.vue?vue&type=script&lang=js"
export * from "./ConsultantLoggedInNavLocaleSelector.vue?vue&type=script&lang=js"
import style0 from "./ConsultantLoggedInNavLocaleSelector.vue?vue&type=style&index=0&id=9a29d888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a29d888",
  null
  
)

export default component.exports